import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=65cb57dc&scoped=true&"
import script from "./agentDetail.vue?vue&type=script&lang=js&"
export * from "./agentDetail.vue?vue&type=script&lang=js&"
import style0 from "./agentDetail.vue?vue&type=style&index=0&id=65cb57dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb57dc",
  null
  
)

export default component.exports